import { css, polished } from 'jimu-core';
export const mobilePanelStyles = (props) => {
    const theme = props.theme;
    return css `
    .expand-mobile-panel {
      background-color: ${theme.ref.palette.white};
      box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 2px;
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
      pointer-events: auto;
      position: relative;
      touch-action: none;
      display: flex;
      flex-flow: column;
    }

    .expand-mobile-panel-transition {
      transition: height 0.3s;
    }

    .expand-mobile-panel-touch-container {
      top: 0;
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 54px;
      touch-action: none;
    }

    .expand-mobile-panel-bar {
      width: 36px;
      height: 4px;
      background-color: ${theme.ref.palette.black};
      border-radius: 2px;
      margin-top: 4px;
    }

    .mobile-panel-content-header {
      height: 54px;
      width: 100%;

    }

    .panel-icon {
      cursor: pointer;
      color: #6e6e6e;
    }

    .panel-icon:hover {
      color: #2e2e2e;
    }

    .panel-title {
      font-weight: bold;
      font-size: ${polished.rem(16)};
      color: ${theme.ref.palette.black};
      padding-right: 1rem;
    }

    .exb-mobile-panel-content {
      height: calc(100% - 30px);
      overflow: auto;
    }

    .mobile-panel-content-header {
      .panel-icon {
        position: relative;
        z-index: 1;
      }
    }
  `;
};
